// extracted by mini-css-extract-plugin
module.exports = {"container":"Section_container__1JwIy","title":"Section_title__NWdUs","count":"Section_count__3TJpV","materialTitle":"Section_materialTitle__gsSl0"};